import { DEBOUNCE_WAIT } from '@vindr/services/constants/common.constant';
import debounce from 'lodash/debounce';
import { useCallback, useState } from 'react';

export const useDebounce = <T>(
  initialState?: any,
  wait = DEBOUNCE_WAIT,
  settings?: Parameters<typeof debounce>['2']
): [T, (val: T) => void] => {
  const [state, setState] = useState<T>(initialState);

  const handleDebounce = useCallback(
    debounce(
      (searchText: T) => {
        setState(searchText);
      },
      wait,
      settings
    ),
    []
  );

  const setDebouncedState = (_val: T) => {
    handleDebounce(_val);
  };

  return [state, setDebouncedState];
};

/**
 * A hook to set a value
 *
 * @param {*} value - A value to "set"
 * @param {number} delay - The debounce delay for setting the value
 * @returns
 */
// export default function useDebounce(value, delay) {
//   const [debouncedValue, setDebouncedValue] = useState(value);

//   useEffect(
//     () => {
//       // Set debouncedValue to value (passed in) after the specified delay
//       const handler = setTimeout(() => {
//         setDebouncedValue(value);
//       }, delay);

//       // Return a cleanup function that will be called every time useEffect is
//       // re-called. useEffect will only be re-called if value changes (see the
//       // inputs array below).
//       //
//       // This is how we prevent debouncedValue from changing if value is changed
//       // within the delay period. Timeout gets cleared and restarted.
//       //
//       // To put it in context, if the user is typing within our app's search
//       // box, we don't want the debouncedValue to update until they've stopped
//       // typing for more than 500ms.
//       return () => {
//         clearTimeout(handler);
//       };
//     },
//     // Only re-call effect if value changes
//     // You could also add the "delay" var to inputs array if you need to be
//     // able to change that dynamically.
//     [value]
//   );

//   return debouncedValue;
// }
